import type { Answer } from '../../../types/answer'
import type { Form } from '../../../types/form'

const buildPreviewFormAnswers = (form: Form): Answer[] => {
  const answers = []
  form.pages.forEach((page) => {
    page.sections.forEach((section) => {
      section.rows.forEach((row) => {
        row.questions.forEach((question) => {
          if (!question.default_value) return
          answers.push({
            id: '',
            question: question.id,
            answer_raw: question.default_value,
            answer_text: question.default_value,
            answer_files: [],
            response: '',
            question_row: null,
            question_column: null,
          })
        })
      })
    })
  })

  return answers
}

export default buildPreviewFormAnswers
